export class UserManagmentUtil {
  static UserManagmentEnum = {
    id: "id",
    user: "user",
    firstName: "firstName",
    lastName: "lastName",
    merchantInfo: {
      merchant: "merchant",
      role: ["role"],
    },
  };
}

export const UserManagementMerhantIdToName = (id, merchantArray) => {
  const foundMerchant = merchantArray?.find((val) => val.merchantId === id);
  const merchantName = foundMerchant ? foundMerchant.merchantName : undefined;

  return merchantName;
};
export const UserManagementNameToMerhantId = (name, merchantArray) => {
  const foundMerchant = merchantArray?.find((val) => val.merchantName === name);
  const merchantId = foundMerchant ? foundMerchant.merchantId : undefined;
  console.log(
    "SELECTED MERCHANT NAME => ",
    name,
    ", MERCHANTARRAY => ",
    merchantArray
  );
  return merchantId;
};

export const SetRolesIntoOneArrayToMerchant = (formData) => {
  const merchantInfoMerged = formData.merchantInfo.reduce((acc, current) => {
    const foundMerchantIndex = acc.findIndex((item) => item.merchantId === current.merchantId);

    if (foundMerchantIndex !== -1) {
      acc[foundMerchantIndex].role.push(current.role);
    } else {
      acc.push({
        merchantId: current.merchantId,
        role: [current.role],
      });
    }
    return acc;
  }, []);

  formData.merchantInfo = merchantInfoMerged;
};

export const SetMerchantArrayForAllUsers = (merchantInfo) => {
    const merchantArray = merchantInfo.reduce((merchant, current) => {
        const foundMerchant = merchant.findIndex((item) => item.merchantName === current.merchantName)

        if (foundMerchant !== -1) {
            merchant[foundMerchant].push(current.merchantName);
          } else {
            merchant.push(current.merchantName);
          }
          return [...new Set(merchant)];
    }, []);
    console.log("ALL MERCHANTS FOR THIS USER => ", merchantArray)
    return merchantArray
}